<template>
    <v-card class="fill-height">
        <v-card-title primary-title>
            <h3 class="headline">Etudes</h3>
            <v-spacer></v-spacer>
            <v-btn right color="primary" :to="{ name: 'study.add' }">
                <v-icon>add</v-icon>
                Créer une étude
            </v-btn>


        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-layout align-center justify-end row>
                <v-flex xs6>
                    <v-text-field v-model="search" append-icon="search" label="Recherche" single-line
                                  hide-details></v-text-field>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-data-table
            class="mx-4"
            :headers="headers"
            :items="studies"
            :search="search"
            :pagination.sync="paginator">
            <template v-slot:items="props">
                <router-link tag="tr" :to="{name: 'study.view', params: { id: props.item.id } }">
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.start_at }}</td>
                    <td>{{ props.item.end_at }}</td>
                    <td>{{ props.item.status }}</td>
                </router-link>

            </template>
            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                    Aucun résultat pour "{{ search }}".
                </v-alert>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
    name: "StudyList",
    computed: mapState({
        studies: state => state.studies.all
    }),
    data() {
        return {
            has_error: false,
            search: '',
            headers: [
                {text: 'Nom', align: 'left', value: 'name'},
                {text: 'Date de début', align: 'left', value: 'start_at'},
                {text: 'Date de fin', align: 'left', value: 'end_at'},
                {text: 'Statut', align: 'left', value: 'status'}
            ],
            paginatorText: "Résultats par page",
            paginator: {
                rowsPerPage: 25,
                sortBy: 'name',
                //descending:true
            }
        }
    },

    mounted() {
        this.getAllStudies()
    },
    methods: {
        ...mapActions('studies', [
            'getAllStudies'
        ])
    }
}
</script>
